import React, { useEffect, useMemo, useState } from 'react';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { PageContainer } from '@/components/ui/PageContainer/PageContainer';
import { apiFetch } from '@/lib/api';

interface UsageRow {
  day: string;
  provider: string;
  model: string;
  purpose: string;
  input_tokens: string;
  output_tokens: string;
  total_cost_usd: string;
  calls: string;
}

export function LLMUsage() {
  const [rows, setRows] = useState<UsageRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiFetch('/api/admin/llm/usage');
        const data = await res.json();
        if (data.success) setRows(data.data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const totalCost = useMemo(() => rows.reduce((acc, r) => acc + parseFloat(r.total_cost_usd || '0'), 0), [rows]);

  return (
    <PageContainer>
      <PageHeader
        title="LLM Usage"
        description="Daily costs and token usage by provider, model and purpose."
      />

      <div className="bg-white border rounded-lg p-4">
        <div className="text-sm text-gray-600">Total cost</div>
        <div className="text-2xl font-bold">${totalCost.toFixed(4)}</div>
      </div>

      <div className="bg-white border rounded-lg overflow-auto mt-6">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b bg-gray-50">
              <th className="p-3">Day</th>
              <th className="p-3">Provider</th>
              <th className="p-3">Model</th>
              <th className="p-3">Purpose</th>
              <th className="p-3">Calls</th>
              <th className="p-3">Input tokens</th>
              <th className="p-3">Output tokens</th>
              <th className="p-3">Cost (USD)</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td className="p-3" colSpan={8}>Loading…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td className="p-3" colSpan={8}>No data</td></tr>
            ) : (
              rows.map((r, idx) => (
                <tr key={idx} className="border-b hover:bg-gray-50">
                  <td className="p-3">{new Date(r.day).toLocaleDateString()}</td>
                  <td className="p-3">{r.provider}</td>
                  <td className="p-3">{r.model}</td>
                  <td className="p-3">{r.purpose}</td>
                  <td className="p-3">{r.calls}</td>
                  <td className="p-3">{r.input_tokens}</td>
                  <td className="p-3">{r.output_tokens}</td>
                  <td className="p-3">${parseFloat(r.total_cost_usd || '0').toFixed(6)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </PageContainer>
  );
}


